import { useEffect, useState } from "react";
import { gw } from "../gateway.js";
import AuthSheet from "../screens/AuthSheet.jsx";

/**
 * 로그인 입구. 익명이면 「로그인」, 계정이 붙어 있으면 그 표시와 로그아웃.
 *
 * 이게 없으면 **다른 기기에서 기존 계정으로 들어올 방법이 없다.**
 * 결과 화면의 저장 시트는 토론을 끝내야 나오므로, 그냥 기록을 보러 온
 * 사람에게는 입구가 아니다.
 */
export default function AccountButton({ user, onChanged, onMyDebates }) {
  const [sheet, setSheet] = useState(false);
  const [menu, setMenu] = useState(false);
  const [admin, setAdmin] = useState(false);

  const anon = !user || user.isAnonymous;

  // 관리자 권한은 커스텀 클레임이고 ID 토큰에 실려 온다. 화면은 링크를 보여줄 뿐,
  // 실제 차단은 Firestore 규칙과 requireAdmin 이 한다.
  useEffect(() => {
    let alive = true;
    if (!user || user.isAnonymous) { setAdmin(false); return; }
    user.getIdTokenResult().then((t) => { if (alive) setAdmin(t.claims.admin === true); }).catch(() => {});
    return () => { alive = false; };
  }, [user]);

  async function signOut() {
    setMenu(false);
    await gw.signOut();
    onChanged?.();
  }

  if (anon) {
    return (
      <div style={{ position: "relative" }}>
        <button type="button" className="pill" style={{ minHeight: 36 }} onClick={() => setMenu((v) => !v)}>
          내 기록
        </button>
        {menu && (
          <div role="menu" className="card"
            style={{ position: "absolute", right: 0, top: 44, zIndex: 20, minWidth: 220, padding: 12, gap: 8 }}>
            <button type="button" className="btn" style={{ minHeight: 44 }}
              onClick={() => { setMenu(false); onMyDebates?.(); }}>지난 토론 보기</button>
            <button type="button" className="btn primary" style={{ minHeight: 44 }}
              onClick={() => { setMenu(false); setSheet(true); }}>로그인</button>
            <span className="note">로그인 안 하면 기록이 이 브라우저에만 있어요.</span>
          </div>
        )}
        {sheet && (
          <AuthSheet
            mode="login"
            onClose={() => setSheet(false)}
            onDone={() => { setSheet(false); onChanged?.(); }}
          />
        )}
      </div>
    );
  }

  const name = user.email || user.displayName || "내 계정";

  return (
    <div style={{ position: "relative" }}>
      {/* 이메일만 띄워 두면 **눌리는 것인지 모른다** — 라벨로 읽힌다.
          로그아웃이 이 안에 들어 있으므로 열린다는 표시가 반드시 있어야 한다. */}
      <button type="button" className="pill" style={{ minHeight: 36, maxWidth: 200 }}
        aria-label={`내 계정 ${name}`} aria-haspopup="menu" aria-expanded={menu}
        onClick={() => setMenu((v) => !v)}>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
        <span aria-hidden="true" style={{
          flexShrink: 0, width: 0, height: 0, marginLeft: 2,
          borderLeft: "4px solid transparent", borderRight: "4px solid transparent",
          borderTop: "5px solid currentColor",
          transform: menu ? "rotate(180deg)" : "none",
        }} />
      </button>
      {menu && (
        <div role="menu" className="card"
          style={{ position: "absolute", right: 0, top: 44, zIndex: 20, minWidth: 220, padding: 12, gap: 8 }}>
          <span className="note" style={{ wordBreak: "break-all" }}>{name}</span>
          <button type="button" className="btn primary" style={{ minHeight: 44 }}
            onClick={() => { setMenu(false); onMyDebates?.(); }}>지난 토론 보기</button>
          {admin && (
            <a className="btn" style={{ minHeight: 44, textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
              href="https://admin.sowhat.run" target="_blank" rel="noreferrer">관리자 페이지</a>
          )}
          <button type="button" className="btn" style={{ minHeight: 44 }} onClick={signOut}>로그아웃</button>
          <span className="note">로그아웃하면 이 브라우저에서는 기록이 안 보여요. 다시 로그인하면 돌아와요.</span>
        </div>
      )}
    </div>
  );
}
